import React, { useState, useEffect, useRef } from "react";
import { Modal, Skeleton, Button, Alert } from "antd";
import { gql, useLazyQuery } from "@apollo/client";
import { PrinterOutlined } from "@ant-design/icons";
import DOMPurify from "dompurify";
import { useReactToPrint } from "react-to-print";
import moment from "moment-jalaali";
import PrintPaper from "@general/printPaper";

const GETHOLIDAY = gql`
  query ($id: ID!) {
    getHoliday(id: $id) {
      contract
      createdAt
    }
  }
`;

function HolidaysTableDetails({ id }) {
  const [contract, setContract] = useState({});
  const [signDate, setSignDate] = useState();

  const contentRef = useRef(null);
  const reactToPrintFn = useReactToPrint({
    contentRef,
    onBeforeGetContent: async () => {
      await document.fonts.ready;
      try {
        await document.fonts.load('18px IRANSansXFaNum');
      } catch (e) {
        console.warn('font load failed', e);
      }
    },
    pageStyle: `
     @font-face {
       font-family: "IRANSansXFaNum";
       src: url("${window.location.origin}/fonts/woff2/IRANSansXFaNum-Regular.woff2") format("woff2");
     }
     .contract-wrapper,
     .contract-wrapper * {
       font-family: "IRANSansXFaNum" !important;
     }
   `,
  });

  const [getHolidaylData, holidayData] = useLazyQuery(GETHOLIDAY, {
    fetchPolicy: "no-cache",
    onError(error) {
      console.log(error.message);
      Modal.error({
        title: "مشکلی پیش آمده!",
        content: "لطفا دوباره تلاش کنید!",
        bodyStyle: { direction: "rtl" },
        okText: "باشه",
      });
    },
    onCompleted({ getHoliday }) {
      const { contract, createdAt } = getHoliday;
      setContract(contract);
      setSignDate(createdAt);
    },
  });
  useEffect(() => {
    if (id) {
      getHolidaylData({
        variables: {
          id,
        },
      });
    }
  }, [id]);

  const cleanedContract = DOMPurify.sanitize(contract);
  if (holidayData.loading)
    return (
      <>
        <Skeleton active round />
        <br />
        <Skeleton active round />
      </>
    );
  if (!contract)
    return (
      <>
        <Alert
          message="این کاربر تعهدنامه امضا شده ندارد"
          type="warning"
          showIcon
        />
      </>
    );
  return (
    <>
      <Button
        type="primary"
        icon={<PrinterOutlined />}
        onClick={reactToPrintFn}
      >
        چاپ تعهدنامه
      </Button>
      <PrintPaper html={contract} ref={contentRef}>
        <span>
          امضا شده در تاریخ {moment(signDate).format("jYYYY/jMM/jDD")} به صورت
          آنلاین توسط کاربر
        </span>
      </PrintPaper>

    </>
  );
}

export default HolidaysTableDetails;
